import type {AppData} from "../types";
const KEY="starfall.worldwarden.v0.2";
const OLD_KEYS=["starfall.worldwarden.v0.1"];
const empty:AppData={
 worlds:[],entities:[],relationships:[],campaigns:[],campaignState:[],campaignEvents:[],
 itemMovements:[],maps:[],itemDefinitions:[],itemInstances:[],creatureDefinitions:[],currencies:[]
};
export const newId=()=>crypto.randomUUID();
export const now=()=>new Date().toISOString();

function normalize(parsed:any):AppData{
 return {
  ...structuredClone(empty),
  ...parsed,
  itemDefinitions:Array.isArray(parsed?.itemDefinitions)?parsed.itemDefinitions:[],
  itemInstances:Array.isArray(parsed?.itemInstances)?parsed.itemInstances:[],
  creatureDefinitions:Array.isArray(parsed?.creatureDefinitions)?parsed.creatureDefinitions:[],
  currencies:Array.isArray(parsed?.currencies)?parsed.currencies:[]
 };
}

export function parseBackup(raw:string):AppData{
 return normalize(JSON.parse(raw));
}

export function loadData():AppData{
 let raw=localStorage.getItem(KEY);
 if(!raw){
  for(const k of OLD_KEYS){ raw=localStorage.getItem(k); if(raw) break; }
 }
 if(!raw) return structuredClone(empty);
 try{return normalize(JSON.parse(raw))}catch{return structuredClone(empty)}
}
export const saveData=(d:AppData)=>localStorage.setItem(KEY,JSON.stringify(d));
export function exportData(d:AppData){
 const b=new Blob([JSON.stringify(d,null,2)],{type:"application/json"});
 const u=URL.createObjectURL(b); const a=document.createElement("a");
 a.href=u;a.download="worldwarden-v0.6-backup.json";a.click();URL.revokeObjectURL(u);
}
